export const getStatus = (status: number): string => {
	switch (status) {
		case 0:
			return "Inactive";
		case 1:
			return "Active";
		default:
			return "Unknown";
	}
};

export const getStatusList = () => {
	return [
		{ value: 0, label: "Inactive" },
		{ value: 1, label: "Active" },
		{ value: 2, label: "Visible" },
	];
};
